exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".block-title[data-v-561d6710]:after {\n  display: none;\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/apps/client/landing/src/views/admin/request/RequestListView.vue"],"names":[],"mappings":"AAOA;EACI,cAAa;CAAA","file":"RequestListView.vue?vue&type=style&index=0&id=561d6710&scoped=true&lang=css&","sourcesContent":["@import \"../../../../../common/styles/user-variables\";\n@import \"../../../../../vendor/createx/styles/helpers\";\n@import \"~bootstrap/scss/functions\";\n@import \"~bootstrap/scss/variables\";\n@import \"~bootstrap/scss/mixins\";\n\n\n.block-title:after {\n    display: none;\n}\n"],"sourceRoot":""}]);

// exports
